<div>
    <app-breadcrumb></app-breadcrumb>
    <h2 class="roboto-medium title ms-4 me-4">Create Event</h2>
</div>

<app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message>

<div class="create-container">
    <div class="create-form-container ms-4 me-4 mb-5 pb-5">
        <!-- <div class="header">Create Event</div> -->
        <div class="mat-typography content">
            <mat-accordion hideToggle multi>
                <mat-expansion-panel [expanded]="true" #panel class="mat-elevation-z0" style="height: 110px;">
                    <mat-expansion-panel-header class="header-container">
                        <mat-panel-title class="roboto-bold me-0">SAFETY ROUTE EVENT DETAILS</mat-panel-title>
                        <!-- <mat-icon class="toggleIcon">{{panel.expanded ? 'remove':'add'}}</mat-icon> -->
                    </mat-expansion-panel-header>
                    <form [formGroup]="safetyRouteEventForm">
                        <div class="d-flex flex-wrap my-3 gap-5">
                            <div class="form-group required eventInput">
                                <label for="routeName" class="control-label">Route Name</label>
                                <div class="d-block">
                                    <input class="form-control" type="text" formControlName="routeName"
                                        [ngClass]="{ 'is-invalid': submitted && form['routeName'].errors }">
                                    <div *ngIf="submitted && form['routeName'].errors" class="invalid-feedback">
                                        <div *ngIf="form['routeName'].errors['required']">
                                            *Please Enter a valid route (XXX-YY)
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group required eventInput">
                                <label for="plannedUnload" class="control-label">Planned Unload</label>
                                <div class="d-block">
                                    <input [ngClass]="{'is-invalid': submitted && form['plannedUnload'].errors }"
                                        class="form-control" type="date" formControlName="plannedUnload">
                                    <div *ngIf="submitted && form['plannedUnload'].errors" class="invalid-feedback">
                                        <div *ngIf="form['plannedUnload'].errors['required']">
                                            Please Enter the Planned Arrival Date.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="button-section">
                                <button class="black-button" (click)="onCreate()">Create</button>
                            </div>
                        </div>
                    </form>
                </mat-expansion-panel>

                <form *ngIf="showSubMenuForm" [formGroup]="subMenuDetailsForm">
                    <mat-expansion-panel [expanded]="true" #panel class="mat-elevation-z0" style="height: 315px;">
                        <mat-expansion-panel-header class="header-container">
                            <mat-panel-title class="roboto-bold me-0">SERIOUS INCIDENT NOTIFICATION (Due within 24
                                hours)
                            </mat-panel-title>
                            <!-- <mat-icon class="toggleIcon">{{panel.expanded ? 'remove':'add'}}</mat-icon> -->
                        </mat-expansion-panel-header>
                        <div class="row d-flex flex-wrap my-3 align-items-start">
                            <div class="form-group required col-md-4 eventInput align-items-start">
                                <label class="col-lg-4 col-md-6 col control-label" for="routeName">Incident Summary
                                    (Who, What,
                                    Where)</label>
                                <div class="col-8">
                                    <textarea class="form-control" (input)="getCharactersLeft($event, 'event')" name=""
                                        id="" cols="30" rows="4" formControlName="commentsInput" [maxLength]="1000"
                                        [ngClass]="{'is-invalid': submitted1 && f['commentsInput'].errors }"></textarea><br>
                                    <div>Character limit: {{num_car_left_comment}} left</div>
                                    <div *ngIf="submitted1 && f['commentsInput'].errors" class="invalid-feedback">
                                        <div *ngIf="f['commentsInput'].errors['required']">
                                            Please Enter the Incident Summary details.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="row mb-3">
                                    <div class="col-md-6 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col control-label" for="region">Region</label>
                                        <div class="d-block">
                                            <select class="" id="region" formControlName="region"
                                                (change)="onRegionChange($event)"
                                                [ngClass]="{'is-invalid': submitted1 && f['region'].errors }">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let region of regionList" [ngValue]="region">
                                                    {{region.itemDesc}}</option>
                                            </select>
                                            <div *ngIf="submitted1 && f['region'].errors" class="invalid-feedback">
                                                <div *ngIf="f['region'].errors['required']">
                                                    Please Select the Region.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col control-label"
                                            for="severity">Severity</label>
                                        <div class="d-block">
                                            <select id="severity" formControlName="severity"
                                                (change)="onSeverityChange($event)"
                                                [ngClass]="{'is-invalid': submitted1 && f['severity'].errors }"
                                                class="">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let sev of severityList" [ngValue]="sev">
                                                    {{sev.itemDesc}}
                                                </option>
                                            </select>
                                            <div *ngIf="submitted1 && f['severity'].errors" class="invalid-feedback">
                                                <div *ngIf="f['severity'].errors['required']">
                                                    Please Select the Severity Type.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col control-label" for="lp">LP</label>
                                        <div class="d-block">
                                            <select class="" id="lp" formControlName="lp" (change)="onLPChange($event)"
                                                [ngClass]="{'is-invalid': submitted1 && f['lp'].errors }">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let lp of lpList" [ngValue]="lp">{{lp.vendorCode}}
                                                </option>
                                            </select>
                                            <div *ngIf="submitted1 && f['lp'].errors" class="invalid-feedback">
                                                <div *ngIf="f['lp'].errors['required']">
                                                    Please Select the Logistic Point(LP).
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col control-label" for="trailer">Trailer</label>
                                        <div class="d-block">
                                            <input class="" type="text" id="trailer"
                                                [ngClass]="{'is-invalid': submitted1 && f['trailer'].errors }"
                                                formControlName="trailer">
                                            <div *ngIf="submitted1 && f['trailer'].errors" class="invalid-feedback">
                                                <div *ngIf="f['trailer'].errors['required']">
                                                    Please enter the Trailer Number.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex flex-wrap my-3 align-items-start">
                            <div class="form-group required eventInput col-md-4">
                                <label class="col-lg-4 col-md-6 col control-label" for="incident-date">Incident
                                    Date</label>
                                <div class="d-block">
                                    <input class="form-control" type="date" formControlName="incidentDateTime"
                                        [ngClass]="{'is-invalid': submitted1 && f['incidentDateTime'].errors }">
                                    <div *ngIf="submitted1 && f['incidentDateTime'].errors" class="invalid-feedback">
                                        <div *ngIf="f['incidentDateTime'].errors['required']">
                                            Please Enter the Incident Date.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group required eventInput col-md-4">
                                <label class="col-lg-3 col-md-6 col control-label" for="incident-date">Incident
                                    Time</label>
                                <div class="d-block">
                                    <!-- <div class="ngx-timepicker-field-example"> -->
                                        <ngx-timepicker-field formControlName="incidentTime" class="form-control timepicker" [format]="24" [defaultTime]="'00:00'" [ngClass]="{'is-invalid': submitted1 && f['incidentTime'].errors }"></ngx-timepicker-field>
                                    <!-- </div> -->

                                    <div *ngIf="submitted1 && f['incidentTime'].errors" class="invalid-feedback">
                                        <div *ngIf="f['incidentTime'].errors['required']">
                                            Please Enter the Incident time.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true" #panel class="mat-elevation-z0" style="height: 320px;">
                        <mat-expansion-panel-header class="header-container">
                            <mat-panel-title class="roboto-bold me-0">INCIDENT TYPE (Due within 48 hours)
                            </mat-panel-title>
                            <!-- <mat-icon class="toggleIcon">{{panel.expanded ? 'remove':'add'}}</mat-icon> -->
                        </mat-expansion-panel-header>

                        <!-- <div class="d-flex flex-wrap my-3 align-items-center">
                            <div class="event-checkbox" *ngFor="let checkbox of checkboxes; let i = index" formArrayName="checkboxes">
                                <input type="checkbox" [formControlName]="i">
                                <label >{{checkbox.name}}</label>
                            </div>
                        </div>  -->

                        <div class="d-flex flex-wrap my-3 align-items-center gap-3">
                            <div class="event-checkbox" *ngFor="let incident of incidentTypes; let i = index"
                                formArrayName="incidentTypes"
                                class="formArrayCheck gap-3 col-md-2 align-items-center eventInput"
                                [ngClass]="{'is-invalid': submitted1 && f['incidentTypes'].errors }">
                                <label class="checkcontainer">{{incident.name}}
                                    <input type="checkbox" [formControlName]="i" (change)="onIncidentTypesChange()">
                                    <span class="checkmark"></span>
                                </label>
                            </div>

                            <div *ngIf="submitted1 && f['incidentTypes'].errors" class="invalid-feedback">
                                <div *ngIf="f['incidentTypes'].errors['incidentNotFound']">
                                    Please Choose at least one Incident Type.
                                </div>
                            </div>
                        </div>
                        <div class="d-flex mb-3">
                            <div *ngIf="burnDetail" class="form-group required eventInput col-md-7">
                                <label class="control-label col-md-2">Burn Details</label>
                                <div class="custom-control custom-radio col-md-3">
                                    <input class="custom-control-input " id="type"
                                        [ngClass]="{'is-invalid': submitted1 && f['burnTypeValue'].errors }"
                                        type="radio" name="burnTypeValue" formControlName="burnTypeValue" value="YES"
                                        (change)="onBurnTypeChange()">
                                    <label class="custom-control-label ms-2" for="type">3 Degree</label>
                                    <div *ngIf="submitted1 && f['burnTypeValue'].errors" class="invalid-feedback">
                                        <div *ngIf="f['burnTypeValue'].errors['required']">
                                            Please choose the Burn Degree.
                                        </div>
                                    </div>
                                </div>
                                <div class="custom-control custom-radio col-md-2">
                                    <input class="custom-control-input " id="type1"
                                        [ngClass]="{'is-invalid': submitted1 && f['burnTypeValue'].errors }"
                                        type="radio" name="burnTypeValue" formControlName="burnTypeValue" value="NO"
                                        (change)="onBurnTypeChange()">
                                    <label class="custom-control-label ms-2" for="type1">2 Degree</label>
                                </div>
                                <div class="input-group">
                                    <input class="form-control"
                                        [ngClass]="{'is-invalid': submitted1 && f['burnTextValue'].errors }" type="text"
                                        formControlName="burnTextValue" (input)="onBurnTextValue()">
                                    <span class="input-group-text" id="basic-addon2">%</span>
                                    <!-- <b
                                        class="me-5">%</b> -->
                                    <div *ngIf="submitted1 && f['burnTextValue'].errors" class="invalid-feedback">
                                        <div *ngIf="f['burnTextValue'].errors['invalidNumber']">
                                            Burn degree value should be number only
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div *ngIf="otherDetail">
                                <div class="form-group required eventInput">
                                    <label class="control-label">Other Details</label>
                                    <div class="d-block">
                                        <input class="form-control" type="text" name="incident_type_text" [maxLength]="30"
                                            id="incident_type_Text" formControlName="incidentTypeText"
                                            [ngClass]="{'is-invalid': submitted1 && f['incidentTypeText'].errors }">
                                        <div *ngIf="submitted1 && f['incidentTypeText'].errors"
                                            class="invalid-feedback">
                                            <div *ngIf="f['incidentTypeText'].errors['required']">
                                                Please Enter the value for the Other.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group required event-textarea col-lg-12 mb-3">
                            <label for="details" class="control-label col-md-1">Incident Details</label>
                            <div class="w-100"><textarea name="" id="details" cols="170" rows="2" (input)="getCharactersLeft($event, 'details')"
                                    formControlName="details" class="form-control detail_area" [maxLength]="2000"
                                    [ngClass]="{'is-invalid': submitted1 && f['details'].errors }"></textarea>
                                    <div>Character limit: {{incident_details_limit}} left</div>
                                <div *ngIf="submitted1 && f['details'].errors" class="invalid-feedback">
                                    <div *ngIf="f['details'].errors['required']">
                                        Please enter the Incident Details.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel [expanded]="true" #panel class="mat-elevation-z0" style="height: 500px;">
                        <mat-expansion-panel-header class="header-container">
                            <mat-panel-title class="roboto-bold me-0">INCIDENT DETAILS (Due within 24 hours)
                            </mat-panel-title>
                            <!-- <mat-icon class="toggleIcon">{{panel.expanded ? 'remove':'add'}}</mat-icon> -->
                        </mat-expansion-panel-header>
                        <div class="d-flex flex-wrap my-3 align-items-center">
                            <div class="eventInput col-lg-4 col-md-6 col">
                                <label class="col-lg-4 col-md-6 col" for="tmtitle">T/M Title</label>
                                <select name="" id="tmtitle" formControlName="tmTitle"
                                    (change)="onTrailerChange($event)">
                                    <option value="">Please Select</option>
                                    <option *ngFor="let item of tmTitleList" [ngValue]="item">{{item.itemDesc}}</option>
                                </select>
                            </div>
                            <div class="eventInput col-lg-4 col-md-6 col">
                                <label class="col-lg-4 col-md-6 col" for="process">Process</label>
                                <select name="" id="process" formControlName="process"
                                    (change)="onTrailerChange($event)">
                                    <option value="">Please select</option>
                                    <option *ngFor="let item of processList" [ngValue]="item">{{item.itemDesc}}</option>
                                </select>
                            </div>
                            <div class="eventInput col-lg-4 col-md-6 col">
                                <label class="col-lg-4 col-md-6 col" for="length-of">Length of Service</label>
                                <select formControlName="los" id="length-of" (change)="onTrailerChange($event)">
                                    <option value="">Please Select</option>
                                    <option *ngFor="let item of losList" [ngValue]="item">{{item.itemDesc}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap my-3 align-items-center">

                            <div class="event-textarea col-lg-4 col-md-6 col align-items-start">
                                <label for="cause-of-incident" class="col-lg-4 col-md-6 col">Cause of Incident</label>
                                <div class="col-8">
                                    <textarea (input)="getCharactersLeft($event, 'incident')" name="" [maxLength]="1000" id="" rows="4"
                                        formControlName="causeOfIncident"></textarea>
                                    <div>Character limit: {{num_car_left_incident}} left</div>
                                </div>

                            </div>
                            <div class="event-textarea col-lg-4 col-md-6 col align-items-start">
                                <label class="col-lg-4 col-md-6 col" for="production-impack">Description (write in
                                    details)</label>
                                <div class="col-8">
                                    <textarea (input)="getCharactersLeft($event, 'desc')" name="" [maxLength]="1000" id="" rows="4"
                                        formControlName="description"></textarea>
                                    <div>Character limit: {{num_car_left_desc}} left</div>
                                </div>
                            </div>
                            <div class="eventInput col-lg-4 col-md-6 col align-items-start">
                                <label class="col-lg-4 col-md-6 col" for="lp-initiated">LP Initiated Counter
                                    Measure</label>
                                <div class="col-8">
                                    <textarea (input)="getCharactersLeft($event, 'counter')" name="" [maxLength]="1000" id="lp-initiated"
                                        cols="30" rows="4" formControlName="lpInitiated"></textarea><br>
                                    <div>Character limit: {{num_car_left_counter}} left</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap my-3 align-items-center">
                            <div class="d-flex">
                                <div class="align-items-start">
                                    <label> Production Impact
                                        <input type="radio" name="productionImpact" value="YES" formControlName="productionImpact"
                                            class="ms-5 me-3" (change)="onProductionImpack()">
                                        <span>YES</span>
                                    </label>
                                    <label>
                                        <input type="radio" name="productionImpact" value="NO" formControlName="productionImpact"
                                            class="ms-3 me-3" (change)="onProductionImpack()">
                                        <span>NO</span>
                                    </label>
                                </div>
                                <div *ngIf="f['productionImpact'].value == 'YES'"
                                    class="form-group required event-textarea align-items-start ms-5">
                                    <label class="control-label" for="production-impack">Production Impact
                                        Desc</label>
                                    <div class="">
                                        <textarea class="form-control" (input)="getCharactersLeft($event, 'prob')"
                                            name="" id="" rows="4" formControlName="productionImpackDesc" [maxLength]="1000"
                                            [ngClass]="{'is-invalid': submitted1 && f['productionImpackDesc'].errors }"></textarea>
                                        <div>Character limit: {{num_car_left_prob}} left</div>
                                        <div *ngIf="submitted1 && f['productionImpackDesc'].errors"
                                            class="invalid-feedback">
                                            <div *ngIf="f['productionImpackDesc'].errors['required']">
                                                Please Enter the Production impact Description.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-block flex-wrap my-3 align-items-baseline">
                            <label class="pi-checkbox-lable mt-2" for="">Production Investigation
                                Checkpoints</label>
                            <div class="d-flex mt-2">
                                <div class="pi-checkbox formArrayCheck" *ngFor="let point of checkpoints; let i = index"
                                    formArrayName="checkpoints">
                                    <label class="checkcontainer">{{point.name}}
                                        <input type="checkbox" [formControlName]="i">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="d-flex flex-wrap my-3 align-items-center row ms-0">
                            <label class="pi-checkbox-lable col-lg-2 ps-0" for="">Production Investication
                                Checkpoints</label>
                            <div class="check-container col-lg-10 d-flex">
                                <div class="pi-checkbox col-lg-2" *ngFor="let point of checkpoints; let i = index"
                                    formArrayName="checkpoints">
                                    <input type="checkbox" [formControlName]="i">
                                    <label for="">{{point.name}}</label>
                                </div>
                            </div>
                        </div> -->
                    </mat-expansion-panel>
                </form>
            </mat-accordion>

        </div>
    </div>

    <div *ngIf="showSubMenuForm" class="create_footer d-flex justify-content-end align-items-center fixed-bottom">
        <button class="cancel me-3 roboto-bold" (click)="onCancel()"> CANCEL </button>
        <button class="black-button me-3 roboto-medium" (click)="onSubmit()">SUBMIT</button>
    </div>
</div>
